import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import * as generic from '../../../../components/Generico';
import { CapacidadEspecial } from '../../../../models/trust/empleado/CapacidadEspecial';
import { EmpleadoAcDirService } from '../../../../service/trust/empleado/EmpleadoAcDirService';
import { PersonaExpuesta } from '../../../../components/trust/PersonaExpuesta';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { Divider } from 'primereact/divider';
import { useSubmitForm } from '../../../../hooks/useSubmitForm';

export const Declaracion = ({ toast, id, permss, nuevoEmpleado, setDialogAnexos, handlePrev, soloLectura }) => {
    const omodel = new CapacidadEspecial();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const empleadoServicio = new EmpleadoAcDirService();
    const { funcMessageBlobError, downloadPdf } = generic.Generico();
    const { inDrop, inText, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = useSubmitForm({
        toast, setError, onSuccess: (res) => {
            // Atrapamos la respuesta del backend y actualizamos el estado de la vista
            if (res?.data?.estado) {
                nuevoEmpleado({ nemonico: res.data.estado }); // En el flujo solo se envia 'ENVIADO'
            }
        }
    });
    // Estados locales
    const [load, setLoad] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);
    // Estados para visibilidad condicional
    const [esPep, setEsPep] = useState(false);
    const [siCarnetConadis, setSiCarnetConadis] = useState(false);
    const [siFamiliarDiscapacidad, setSiFamiliarDiscapacidad] = useState(false);
    const [tienePeps, setTienePeps] = useState(false);
    const [siAcuerdo, setSiAcuerdo] = useState(false);

    useEffect(() => {
        editFicha();
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const editFicha = () => {
        setIsLoading(true);
        empleadoServicio.consultar(id, { seccion: 'seccion5' }).then(res => {
            if (res.data.anexos_requisitos !== undefined) setAnexosRequisitos(res.data.anexos_requisitos);
            const _emp = res.data.empleado;
            if (!_emp) { reset(defaultValues); return; }
            setTienePeps(res.data.tiene_peps || false);
            setSiCarnetConadis(_emp.carnet_conadis?.cat_id === true);
            setSiFamiliarDiscapacidad(_emp.familiar_pendiente_discapacidad?.cat_id === true);
            setEsPep(_emp.familiar_pep?.cat_id === true);
            reset(generic.renewValues(_emp, omodel.model));
            setSiAcuerdo(_emp.tipo_declaracion === 'TP_DEC_TF_INICIO_GESTION' && _emp?.declarantes?.includes('TP_DEC_TF_EMPLEADO'));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion5';
        setLoad(true);
        empleadoServicio.editar(data).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const onChangePep = (e) => {
        setEsPep(e.value?.cat_id === true);
    }

    // Función que recibe el total de registros desde el hijo
    const handlePepChange = (total) => {
        setTienePeps(total > 0);
    };

    const onChangeCarnetConadis = (e) => {
        setSiCarnetConadis(e.value?.cat_id === true);
        setValue('discapacidad', '');
        setValue('porcentaje_discapacidad', null);
    }

    const onChangeFamiliarDiscapacidad = (e) => {
        setSiFamiliarDiscapacidad(e.value?.cat_id === true);
        setValue('parentesco_familiar_pendiente', '');
        setValue('tipo_discapacidad_familiar_pendiente', '');
        setValue('porcentaje_discapacidad_familiar_pendiente', null);
    }

    const generarReporte = (opcion = '') => {
        setLoadReport(true);
        empleadoServicio.descargar(id, { tipo: opcion }).then(res => {
            let nameFile = `${id}-Formulario-Informacion-Empleado.pdf`;
            if (opcion === 'licitud') nameFile = `${id}-Declaracion-Licitud-Ingresos.pdf`;
            if (opcion === 'adicional') nameFile = `${id}-Licitud-Adicional-Ingresos.pdf`;
            if (opcion === 'acuerdoUso') nameFile = `${id}-Acuerdo-Uso.pdf`;
            if (opcion === 'acuerdoConfidencialidad') nameFile = `${id}-Acuerdo-Confidencialidad.pdf`;
            downloadPdf(res, nameFile);
        }).catch(error => {
            funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => { if (setDialogAnexos) setDialogAnexos(true); }

    const enviar = () => {
        enviarFormulario(id, 'ficha/trust/empleado-ac-dir/enviar', 'empleadoAcDir');
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores en la validación.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    // Botones para los reportes extras
    const customButtons = soloLectura ? [] : [
        {
            label: 'Licitud',
            icon: 'pi pi-check-square',
            onClick: () => generarReporte('licitud'),
            loading: loadReport,
            className: 'p-button-secondary',
            tooltip: 'Declaración de Licitud de Ingresos'
        },
        {
            label: 'Licitud adicional',
            icon: 'pi pi-plus-circle',
            onClick: () => generarReporte('adicional'),
            loading: loadReport,
            className: 'p-button-secondary',
            tooltip: 'Licitud Adicional de Ingresos'
        }
    ];

    // Botones adicionales en función de siAcuerdo
    if (!soloLectura && siAcuerdo) {
        customButtons.push(
            {
                label: 'Acuerdo Uso',
                icon: 'pi pi-desktop',
                onClick: () => generarReporte('acuerdoUso'),
                loading: loadReport,
                className: 'p-button-info',
                tooltip: 'Acuerdo de Uso'
            },
            {
                label: 'Confidencialidad',
                icon: 'pi pi-lock',
                onClick: () => generarReporte('acuerdoConfidencialidad'),
                loading: loadReport,
                className: 'p-button-info',
                tooltip: 'Acuerdo de Confidencialidad'
            }
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('11', 'CAPACIDADES ESPECIALES', 'pi pi-heart')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid p-2">
                    {inDrop('carnet_conadis', generic.estadosSiNo, { lab: 'nombre', chn: onChangeCarnetConadis }, 12)}
                    {siCarnetConadis && (
                        <>
                            {inText('discapacidad', { icon: 'pi pi-user' }, 8)}
                            {inNumber('porcentaje_discapacidad', 2, false, { icon: 'pi pi-money-bill', iconPosition: 'left' }, 4)}
                        </>
                    )}
                    <Divider type="dashed" />
                    {inDrop('familiar_pendiente_discapacidad', generic.estadosSiNo, { lab: 'nombre', chn: onChangeFamiliarDiscapacidad }, 12)}
                    {siFamiliarDiscapacidad && (
                        <>
                            {inText('parentesco_familiar_pendiente', { icon: 'pi pi-users' }, 4)}
                            {inText('tipo_discapacidad_familiar_pendiente', { icon: 'pi pi-user' }, 4)}
                            {inNumber('porcentaje_discapacidad_familiar_pendiente', 2, false, { icon: 'pi pi-money-bill', iconPosition: 'left' }, 4)}
                        </>
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('12', 'DECLARACIÓN DE PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid p-2">
                    <div className="col-12 mb-3">{omodel.declaracionPep}</div>
                    {inDrop('familiar_pep', generic.estadosSiNo, {
                        lab: 'nombre', chn: onChangePep, val: true, ne: tienePeps,
                        helpText: tienePeps ? "No editable: Ya existe un PEP asociado. Debe eliminarlo todos si desea cambiar esta opción." : null
                    }, 12)}
                </div>
                {esPep && <PersonaExpuesta toast={toast} id={id} permss={permss} soloLectura={soloLectura} onPepChange={handlePepChange} />}
            </Panel>

            <Panel header={generic.renderPanelHeader('13', 'CERTIFICACIÓN', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-check-circle text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Certificación de Veracidad y Reporte Fiscal</span>
                    </div>
                    {omodel.msgDeclaracion}
                </div>
                <div className="formgrid grid p-2">
                    {inText('observacion', {}, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-shield text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                    </div>
                    {omodel.msgTratamientoDatos}
                </div>
            </Panel>

            {anexosRequisitos.length > 0 && (
                <Panel header={generic.renderPanelHeader('', 'Anexos Requeridos', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-file text-yellow-600 text-lg"></i>
                            <span className="font-bold text-yellow-900">Documentos requeridos</span>
                        </div>
                        <ul className="pl-4 m-0">
                            {anexosRequisitos.map((req, index) => (
                                <li key={index} className="mb-1">{req}</li>
                            ))}
                        </ul>
                    </div>
                </Panel>
            )}

            <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onSave={true} onGenerate={() => generarReporte()} onSend={enviar}
                onAttachments={subirReporte} loading={load || loadReport} isReadOnly={soloLectura} enableExtras={id != null}
                customButtons={customButtons}
            />
        </form>
    );
}
